import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <Header />

        <main className="cart">
          <div className="cart-empty">
            <h2>Your Cart</h2>
            <p>Your cart is empty.</p>
            <Link onClick={toTop} to="/shop" className="btn primary">
              Continue Shopping
            </Link>
          </div>
        </main>

        <Footer />
      </div>
    );
  }

  return (
    <div className="cart-page">
      <Header />

      <main className="cart">
        <div className="cart-grid">
          <section className="cart-left">
            <h2 className="cart-title">Your Cart</h2>
            <div className="cart-steps">
              Cart &gt; Information &gt; Shipping &gt; Payment
            </div>

            {cartItems.map((item) => {
              const product = getProductById(item.id);
              if (!product) return null;
              const price = parseFloat(product.price.replace(/,/g, ""));
              const line = price * item.quantity;
              return (
                <div
                  className="cart-item"
                  key={`${item.id}-${item.size}-${item.color}`}
                >
                  <div className="cart-item-media">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="cart-item-body">
                    <div className="cart-item-name">{product.name}</div>
                    <div className="cart-item-opts">
                      {item.color || "White"} / {item.quantity}-pack / Plug-In
                    </div>

                    <div className="cart-item-actions">
                      <div className="qty">
                        <button
                          className="qty-btn"
                          onClick={() =>
                            handleUpdateQuantity(
                              item.id,
                              item.size,
                              item.color,
                              item.quantity - 1
                            )
                          }
                          aria-label="Decrease"
                        >
                          −
                        </button>
                        <span className="qty-num">{item.quantity}</span>
                        <button
                          className="qty-btn"
                          onClick={() =>
                            handleUpdateQuantity(
                              item.id,
                              item.size,
                              item.color,
                              item.quantity + 1
                            )
                          }
                          aria-label="Increase"
                        >
                          +
                        </button>
                      </div>
                      <button
                        className="link-danger"
                        onClick={() =>
                          removeFromCart(item.id, item.size, item.color)
                        }
                      >
                        Remove
                      </button>
                    </div>

                    <div className="delivery">
                      Fastest delivery on Mon, Mar 9
                    </div>
                  </div>
                  <div className="cart-item-price">€{line.toFixed(2)}</div>
                </div>
              );
            })}

            <div className="cart-note">
              Rivergrove offers free expedited shipping for orders over €49 and
              free returns for all orders purchased on www.rivergrove.blog.
              Visit{" "}
              <Link onClick={toTop} to="/terms">
                Rivergrove’s Terms and Conditions
              </Link>{" "}
              for more details.
            </div>
          </section>

          <aside className="cart-right">
            <h3 className="summary-title">Summary</h3>
            <div className="summary-row">
              <span>Subtotal</span>
              <span>€{subtotal.toFixed(2)}</span>
            </div>
            <div className="summary-row">
              <span>Shipping</span>
              <span className="free">Free</span>
            </div>
            <div className="summary-total">
              <span>Total</span>
              <span>€{subtotal.toFixed(2)}</span>
            </div>
            <div className="summary-finance">
              Take up to 18 months to pay with as low as 0% APR on some term
              lengths and no late fees.{" "}
              <Link onClick={toTop} to="/terms">
                Prequalify now
              </Link>
            </div>
            <button
              className="btn primary summary-checkout"
              onClick={handleCheckout}
            >
              Proceed to checkout
            </button>
          </aside>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CartPage;
